import React, { Fragment } from 'react';
import { MDBBtn,MDBIcon,MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBInput,MDBListGroup, MDBListGroupItem, MDBContainer } from "mdbreact";
import 'font-awesome/css/font-awesome.min.css';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import _ from 'lodash';
import moment from 'moment';
import {browserHistory} from 'react-router';
var PouchDB = require('pouchdb');
PouchDB.plugin(require('pouchdb-find'));
import firebase from "../firebase.js";

var db ;//= new PouchDB('tasks');
var db_timetracker ;//= new PouchDB('timetracker');

class TodoList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      clicked:null      
    }
  }

  componentDidMount() {
    console.log("component did mount push data",global.uid);
  }
 
  handleTouchEnd  = (index)  => {
    this.setState({clicked:index});
    this.props.showOptions(index);
  }

  render () {
    const { clicked } = this.state;
    var todoItems = this.props.items || [];
    var items = todoItems.map((item, index) => {
      return (
        <MDBListGroupItem key={index} className={clicked === index && "active"} onTouchEnd={this.handleTouchEnd.bind(this,index)}>
          <div className="d-flex w-100 justify-content-between">
          <h5 className="mb-1">{item.name}</h5>
          <small>{item.time_elapsed}</small>
          </div>
        </MDBListGroupItem>
      );
    });
    return (
      <MDBContainer>
        <MDBListGroup style={{ width: "22rem", height: "200px", overflow: "auto" }}>
        {items}
        </MDBListGroup>
      </MDBContainer>
    );
  }
}

class TodoHeader extends React.Component {
    render () {
      return <div className="center"><h3>Task Tracker</h3></div>;
    }
}
  
export default class TodoApp extends React.Component {
    constructor (props) {
      super(props);
      this.user;
      this.selectedItem;
      this.selectedIndex;
      this.state = {todoItems: [], checked:false, modal:false, name: "", isEdit:false, disable_start:"",disable_stop:""};
    }
    
    componentDidMount = async() => {
      firebase.auth().onAuthStateChanged(async(user) => {
        this.user = user;
        const tasks = firebase.firestore().collection('tasks');
        const query = tasks.where('uid', '==', user.uid);
        var response = await query.get();
        response.forEach(doc => {
          const data = doc.data();
          data.id = doc.id
          this.checkRunningStatus(data);
          this.setState({todoItems: this.state.todoItems.concat(data)})
        })
      })            
    }
    
    checkRunningStatus = async(item) => {
      if(item.start_time) {
          var now = moment(new Date());
          var end = moment.unix(item.start_time.seconds).format("YYYY-MM-DD HH:mm");
          var time_elapsed = moment.duration(now.diff(end));
          console.log("time elapsed",time_elapsed.hours(),time_elapsed.minutes());
          if(parseInt(time_elapsed.hours())){
            item.time_elapsed = parseInt(time_elapsed.hours()) + " hrs " + parseInt(time_elapsed.minutes()) + " mins";
          } else {
            item.time_elapsed = parseInt(time_elapsed.minutes()) + " mins";
          }
      }  
    }

    removeItem  = async() => {
      var todoItems = this.state.todoItems;
      var itemIndex = this.selectedIndex;
      var todo = todoItems[itemIndex];
      todoItems.splice(itemIndex,1);
      this.setState({todoItems: todoItems});
      var task_col = firebase.firestore().collection('tasks');
      var err = await task_col.doc(todo.id).delete();
      if(err) {
        console.log("Error Deleting Task",err);
      }
    }
   
    showOptions = (itemIndex) => {
      var todoItems = this.state.todoItems;
      this.selectedIndex = itemIndex;
      var todo = todoItems[itemIndex];
      if(todo.stop_time) {
        this.setState({disable_start:"disabled",disable_stop:"disabled"});
      }
      else if(todo.start_time) {
        this.setState({disable_start:"disabled",disable_stop:""});
      }
      else {
        this.setState({disable_start:"",disable_stop:""});
      }
    }
  
    toggle = () => {
      this.setState({modal:!this.state.modal,isEdit:false,name:""});
    }  
    
    saveTask = async(name) => {
      console.log("save task name",name);
      this.toggle();
      var f_id = new Date().valueOf().toString();
      const data = {uid: this.user.uid, name: name, id: f_id};
      console.log("data ",data);
      this.setState({todoItems: this.state.todoItems.concat(data)});
      const tasks = firebase.firestore().collection('tasks');
      const doc_ref = await tasks.doc(f_id).set(data);
      console.log("doc ref",doc_ref);           
    }
    
    handleInput = (val) => {
      console.log("handle input",val.target.value);
      this.setState({name: val.target.value});
    }

    startTask = async() => {
      var todoItems = this.state.todoItems;
      var itemIndex = this.selectedIndex;
      var todo = todoItems[itemIndex];
      const task = firebase.firestore().collection('tasks').doc(todo.id);
      task.update({ start_time: new Date() })
      this.setState({disable_start: "disabled",todoItems: todoItems});
    }

    stopTask = async() => {
      var todoItems = this.state.todoItems;
      var itemIndex = this.selectedIndex;
      var todo = todoItems[itemIndex];
      const task = firebase.firestore().collection('tasks').doc(todo.id);
      task.update({ stop_time: new Date() })
      this.setState({disable_start:"disabled",disable_stop:"disabled"});
      this.setState({todoItems: todoItems});
    }  
    
    editItem = () => {
      var todoItems = this.state.todoItems;
      this.toggle();
      this.setState({isEdit:!this.state.isEdit});
      var itemIndex = this.selectedItem.index;
      var todo = _.find(todoItems,{"index":itemIndex});
      this.setState({name:todo.value});
    }

    history = () => {
      console.log("hostory call");
      browserHistory.push("/history");
    }
   
    render() {
      return (
        <div className="main">
          <TodoHeader />
          { this.state.todoItems.length>0 ? <TodoList items={this.state.todoItems} removeItem={this.removeItem} markTodoDone={this.markTodoDone} showOptions={this.showOptions}/> : null }
          <div className="buttons">
            <div className="options-button">
              <Fragment>
                  <MDBBtn tag="a" className={this.state.disable_start} onClick={this.startTask}>
                    <MDBIcon icon="caret-right" size="lg"/>
                  </MDBBtn>                           
                  <MDBBtn tag="a" className={this.state.disable_stop} onClick={this.stopTask}>
                    <MDBIcon icon="stop-circle" size="lg"/>
                  </MDBBtn>              
                <MDBBtn tag="a" onClick={this.removeItem}>
                  <MDBIcon icon="trash" size="lg"/>
                </MDBBtn>                
              </Fragment>
            </div>
            <div className="home-button">
              <Fragment>              
                <MDBBtn tag="a">
                  <MDBIcon icon="home" size="lg"/>
                </MDBBtn>

                <Fab aria-label="Add" className="add-button" color="primary" onClick={this.toggle}>
                  <AddIcon />
                </Fab>
                <MDBBtn tag="a" onClick={this.history}>
                  <MDBIcon icon="history" size="lg"/>
                </MDBBtn>                           
              </Fragment>
            </div>           
          </div>
          <MDBModal isOpen={this.state.modal}>
            <MDBModalBody>
              <MDBInput type="textarea" label="Create Task" onChange={this.handleInput} rows="2" />
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={this.toggle}>Close</MDBBtn>
              <MDBBtn color="primary" onClick={() => this.saveTask(this.state.name)}>Save</MDBBtn>
            </MDBModalFooter>
          </MDBModal>          
        </div>
      );
    }
  }



// WEBPACK FOOTER //
// ./src/container/Tasks/index.js